<template>
    <div id="footer">
       <div class="footer-content"><span>© 2019-{{thisYear}} iloongplus.com，上海林云隆嘉信息科技有限公司 All Rights Reserved. <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">沪ICP备19024726-1</a></span></div>
    </div>
</template>

<script>
    export default {
      name: "Footer",
      data () {
        return {
          thisYear :2020,
        }
      },
      mounted () {
        this.getYear()
      },
      methods: {
        getYear(){
          let nowDate = new Date();
          this.thisYear = nowDate.getFullYear()
        }
      }
    }
</script>

<style scoped>
    #footer{
        width: 100%;
        overflow: hidden;
        margin: 15px 0;
        color: #333333;
    }
    .footer-content{
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        margin: 80px 0 30px 0;
    }
</style>